import type {FetchTaskPath, FetchTaskResponse} from '../../http';
import {fetchTask} from '../../http';
import {useQuery, UseQueryOptions} from 'react-query';

export function useFetchTask(path: FetchTaskPath, options?: UseQueryOptions<FetchTaskResponse>) {
	return useQuery<FetchTaskResponse>({
		queryKey: ['task', path.id],
		queryFn: async ({signal}) => {
			const {data} = await fetchTask(path, signal);

			return data;
		},
		...options,
	});
}
